import './types.js';
import { globalStyleSheet } from "@/assets/css/global";
import '@/components/reusable/RIcon';
import nextIcon from '@/assets/images/next.svg';
import '@/components/reusable/RPlaylistCover';
import '@/components/reusable/RPlayerProgressBar';
import '@/components/reusable/RPlayerRepeatButton';
import '@/components/reusable/RPlayerPlayButton';
import '@/components/reusable/RCloseButton';
import '@/components/WPlayer/WPlayerQueue';
import { player } from "@/utils/player";
import { eventEmitter } from "@/utils/eventEmitter";
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
    :host {
        display: flex;
        flex-direction: column;
        gap: 20px;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: var(--color-block);
        z-index: 100;
        position: absolute;
        padding: 20px;
    }
    
    r-playlist-cover {
        width: 200px;
    }
    
    .title {
        font-weight: bold;
        font-size: 24px;
    }
    
    .main-controls {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        width: 100%;
    }
    
    .secondary-controls {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
    
    button {
        outline: none;
        padding: 0;
        background: transparent;
    }
    
    .rotated {
        transform: rotate(180deg);
    }
    
    .container {
        max-width: 700px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        margin: 0 auto;
    }
    
    r-close-button {
        margin-left: auto;
    }
`);
export class WPlayerExtended extends HTMLElement {
    value;
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [globalStyleSheet, styleSheet];
    }
    connectedCallback() {
        this.#abortController = new AbortController();
        this.#initDOM();
    }
    disconnectedCallback() {
        this.#abortController.abort();
        this.#events.forEach(({ title, id }) => {
            eventEmitter.remove(title, id);
        });
        this.#events.clear();
    }
    /** @type {AbortController | undefined} */
    #abortController;
    #events = new Set();
    get #closeButtonEl() {
        return this.shadowRoot.querySelector('r-close-button');
    }
    #initDOM() {
        const { cover } = player.currentTrack;
        this.shadowRoot.innerHTML = `
            <r-close-button></r-close-button>
            <div class="container">
                <r-playlist-cover src="${cover}"></r-playlist-cover>
                <div class="title"></div>
                <r-player-progress-bar></r-player-progress-bar>
                <div class="main-controls">
                    <button class="control-button" id="previous">
                        <r-icon url="${nextIcon}" class="rotated"></r-icon>
                    </button>
                    <r-player-play-button></r-player-play-button>
                    <button class="control-button" id="next">
                        <r-icon url="${nextIcon}"></r-icon>
                    </button>
                </div>
                <div class="secondary-controls">
                    <r-player-repeat-button></r-player-repeat-button>
                    <w-player-queue></w-player-queue>
                </div>
            </div>
        `;
        this.#updateData();
        this.#nextEl.addEventListener('click', () => {
            player.next();
            this.#updateData();
        }, { signal: this.#abortController.signal });
        this.#previousEl.addEventListener('click', () => {
            player.previous();
            this.#updateData();
        }, { signal: this.#abortController.signal });
        this.#closeButtonEl.addEventListener('click', () => {
            this.remove();
        });
        const title = 'current track change';
        const { id } = eventEmitter.on(title, () => {
            this.#updateData();
        });
        this.#events.add({ title, id });
    }
    /** @returns {HTMLButtonElement} */
    get #nextEl() {
        return this.shadowRoot.querySelector('#next');
    }
    /** @returns {HTMLButtonElement} */
    get #previousEl() {
        return this.shadowRoot.querySelector('#previous');
    }
    /** @returns {HTMLDivElement} */
    get #titleEl() {
        return this.shadowRoot.querySelector('.title');
    }
    #updateData() {
        this.#titleEl.innerText = player.currentTrack.title;
    }
}
customElements.define('w-player-extended', WPlayerExtended);
